export { SysqueTabModule } from './sysque-tab.module';
export { SysqueTabComponent } from './sysque-tab.component';